import React, { useState, useEffect } from "react";
import { useLang } from "../context/LanguageContext";
import { useCart } from "../context/CartContext";
import { WHATSAPP_NUMBER } from "../lib/whatsapp";

const WhatsAppButton = () => {
  const { lang } = useLang();
  const { drawerOpen } = useCart();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200); // gentle entrance
    return () => clearTimeout(t);
  }, []);

  // Hide whenever the cart drawer is open so it doesn't cover the checkout note
  if (drawerOpen) return null;

  const labelFR = "Discutez avec nous";
  const labelEN = "Chat with us";
  const label = lang === "en" ? labelEN : labelFR;

  const message =
    lang === "en"
      ? "Hello Maison Marigold, I have a question about a piece."
      : "Bonjour Maison Marigold, j'ai une question sur une pièce.";

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid="whatsapp-float"
      className={`fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[80] group flex items-center gap-3 pl-2 pr-4 py-2 rounded-full bg-[#E8E0CE] text-[#1E2B3C] shadow-[0_8px_30px_rgba(30,43,60,0.18)] hover:shadow-[0_12px_40px_rgba(30,43,60,0.28)] hover:bg-[#DDD2BB] transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
      }`}
    >
      {/* Logo circle with WhatsApp glyph badge */}
      <span className="relative inline-flex shrink-0">
        <span className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-[#FAF9F6] flex items-center justify-center overflow-hidden ring-1 ring-[#D6CBB3]">
          <img
            src="/marigold-logo.png"
            alt=""
            className="w-9 h-9 md:w-10 md:h-10 object-contain select-none"
            draggable={false}
          />
        </span>
        {/* WhatsApp badge — marigold orange to match the logo flower */}
        <span className="absolute -bottom-0.5 -right-0.5 w-5 h-5 md:w-[22px] md:h-[22px] rounded-full bg-[#B34A36] flex items-center justify-center ring-2 ring-[#E8E0CE]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-3 h-3 md:w-3.5 md:h-3.5 fill-white"
            aria-hidden="true"
          >
            <path d="M19.05 4.91A9.86 9.86 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.37a9.9 9.9 0 0 0 4.74 1.2h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24h-.01a8.21 8.21 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.19-.31a8.18 8.18 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.41a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.69 8.24-8.23 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.24-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.42-.14-.01-.31-.01-.48-.01-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.06 0 1.21.89 2.38 1.01 2.55.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z" />
          </svg>
        </span>
      </span>

      {/* Label */}
      <span className="font-serif-display text-base md:text-lg leading-none tracking-tight whitespace-nowrap pr-1">
        {label}
      </span>
    </a>
  );
};

export default WhatsAppButton;
